<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <b-form @submit.stop.prevent="handleSubmit">
          <fieldset>
            <table class="table">
              <thead>
                <tr>
                  <th>Notify when...</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in mailboxSettings" :key="row.id">
                  <td>{{row.event_description}}</td>
                  <td><b-form-checkbox
                        v-model="row.slack"></b-form-checkbox>
                  </td>
                </tr>
              </tbody>
            </table>
          </fieldset>
          <b-button type="submit">Save</b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MailboxNotificationSettings',
  props: ['mailbox'],
  data () {
    return {
      mailboxSettings: []
    }
  },

  created () {
    this.getSettings()
  },

  methods: {
    getSettings () {
      var vm = this
      this.$http
        .get('/notification_settings', {params: {mailbox_id: vm.mailbox.id}})
        .then(function (response) {
          vm.mailboxSettings = response.data.mailbox_settings
        })
        .catch(e => { console.log(e) })
    },

    handleSubmit () {
      var vm = this
      this.$http.post('/notification_settings/', {mailbox_settings: vm.mailboxSettings})
        .then(response => this.submitSuccessful(response))
        .catch(e => { console.log(e) })
    },

    submitSuccessful () {
      this.$router.push('/admin/mailboxes')
    }
  },
  watch: {
    mailbox: function () {
      this.getSettings()
    }
  }
}
</script>
<style scoped>
.customize-notifications {
  text-align: left
}
</style>



// WEBPACK FOOTER //
// src/components/admin/MailboxNotificationSettings.vue